import { Reveal } from "@/components/motion";
import { Section, Eyebrow, CTA } from "@/components/kit";
import { PassportStamp } from "@/components/PassportStamp";
import { SEASON2, SEASON2_META } from "@/data/content";

// Sección de la nueva ruta de la Temporada 2 (6 primeros destinos)
export const Season2Route = ({ alt = false }) => (
  <Section alt={alt}>
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <Eyebrow color="#E8C547">Temporada 02 · Nueva ruta</Eyebrow>
        <h2 className="mt-4 max-w-xl font-display text-4xl sm:text-5xl font-extrabold leading-none tracking-tighter text-ink">
          Doce destinos para volver a mirar
        </h2>
      </div>
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-ink/40">
        01—12 · En orden
      </span>
    </div>
    <p className="mt-5 max-w-2xl text-lg text-ink/70 leading-relaxed">
      {SEASON2_META.subtitle}
    </p>

    <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {SEASON2.map((e, i) => (
        <Reveal
          key={e.n}
          delay={(i % 3) * 0.08}
          className="group relative overflow-hidden rounded-[2rem] bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
        >
          <div className="relative h-52 overflow-hidden">
            <img
              src={e.img}
              alt={`${e.city} — Temporada 2`}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
            <div className="absolute -bottom-4 right-4">
              <PassportStamp
                code={e.code}
                label="TEMP.2"
                color={e.color}
                rotate={(i % 2 ? 1 : -1) * 10}
                size={82}
              />
            </div>
            <span className="absolute left-4 top-4 rounded-full bg-cream/90 px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest text-ink">
              Ep {e.n}
            </span>
          </div>
          <div className="p-6">
            <p className="font-mono text-[11px] uppercase tracking-widest text-ink/40">
              {e.country} · {e.theme}
            </p>
            <h3 className="mt-1 font-display text-2xl font-extrabold tracking-tight text-ink">
              {e.city}
            </h3>
            <p className="mt-3 text-sm text-ink/70 leading-relaxed">{e.blurb}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <div className="mt-12 flex flex-wrap items-center gap-4">
      <p className="font-mono text-xs uppercase tracking-widest text-ink/40">
        Doce destinos · Temporada 2 completa
      </p>
      <CTA to="/believers" variant="coral" data-testid="season2-route-cta">
        Avísame del estreno
      </CTA>
    </div>
  </Section>
);
